import { render, staticRenderFns } from "./EditDimension.vue?vue&type=template&id=0afaf580&"
import script from "./EditDimension.vue?vue&type=script&lang=ts&"
export * from "./EditDimension.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports